import { formatCPForCNPJ } from '../../../../utils/helpers'

angular.module("eficienciaFiscalModule").filter("cpfCnpj", () => {
  return (input_value) => formatCPForCNPJ(input_value)    
})
